export const messages = {
  en: {
    borrowManage: {
      search: {
        title: 'Search Conditions',
        borrowId: 'Please enter borrow ID',
        titlePlaceholder: 'Please enter title',
        typeCd: 'Please select borrow type',
        staffName: 'Please enter publisher name'
      },
      list: {
        title: 'Borrow List'
      },
      table: {
        borrowId: 'Borrow ID',
        title: 'Title',
        typeCd: 'Type',
        headerImg: 'Image',
        quantity: 'Quantity',
        unitPrice: 'Unit Price',
        location: 'Location',
        userName: 'Publisher'
      },
      add: {
        title: 'Add Borrow',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Borrow Type',
        typeCdPlaceholder: 'Required, please select type',
        headerImg: 'Header Image',
        quantity: 'Quantity',
        quantityPlaceholder: 'Required, please enter quantity',
        unitPrice: 'Unit Price',
        unitPricePlaceholder: 'Required, please enter unit price',
        location: 'Pickup Location',
        locationPlaceholder: 'Required, please enter pickup location',
        context: 'Content'
      },
      edit: {
        title: 'Edit Borrow',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Borrow Type',
        typeCdPlaceholder: 'Required, please select type',
        headerImg: 'Header Image',
        quantity: 'Quantity',
        quantityPlaceholder: 'Required, please enter quantity',
        unitPrice: 'Unit Price',
        unitPricePlaceholder: 'Required, please enter unit price',
        location: 'Pickup Location',
        locationPlaceholder: 'Required, please enter pickup location',
        context: 'Content'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this borrow?'
      },
      validate: {
        titleRequired: 'Title is required',
        titleMaxLength: 'Title cannot exceed 200 characters',
        typeCdRequired: 'Type is required',
        headerImgRequired: 'Header image is required',
        contextRequired: 'Content',
        quantityRequired: 'Quantity is required',
        quantityFormat: 'Quantity must be a number',
        unitPriceRequired: 'Unit price is required',
        unitPriceFormat: 'Unit price format is incorrect',
        locationRequired: 'Location is required',
        borrowIdRequired: 'Borrow ID is required',
        imageSize: 'Image size cannot exceed 2MB'
      }
    }
  },
  zh: {
    borrowManage: {
      search: {
        title: '查询条件',
        borrowId: '请输入借用ID',
        titlePlaceholder: '请输入标题',
        typeCd: '请选择借用类型',
        staffName: '请输入发布人名称'
      },
      list: {
        title: '物品借用列表'
      },
      table: {
        borrowId: '借用ID',
        title: '标题',
        typeCd: '类型',
        headerImg: '图片',
        quantity: '数量',
        unitPrice: '单价',
        location: '领取地点',
        userName: '发布人'
      },
      add: {
        title: '添加物品借用',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        typeCdPlaceholder: '必填，请选择类型',
        headerImg: '物品照片',
        quantity: '物品数量',
        quantityPlaceholder: '必填，请输入物品数量',
        unitPrice: '物品单价',
        unitPricePlaceholder: '请输入物品单价',
        location: '领取地点',
        locationPlaceholder: '请输入领取地点',
        context: '物品描述'
      },
      edit: {
        title: '编辑物品借用',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        typeCdPlaceholder: '必填，请选择类型',
        headerImg: '物品照片',
        quantity: '物品数量',
        quantityPlaceholder: '必填，请输入物品数量',
        unitPrice: '物品单价',
        unitPricePlaceholder: '请输入物品单价',
        location: '领取地点',
        locationPlaceholder: '请输入领取地点',
        context: '物品描述'
      },
      delete: {
        title: '确认操作',
        confirmText: '确认删除该物品借用吗？'
      },
      validate: {
        titleRequired: '标题不能为空',
        titleMaxLength: '标题不能超过200个字符',
        typeCdRequired: '类型不能为空',
        headerImgRequired: '物品照片不能为空',
        contextRequired: '物品描述不能为空',
        quantityRequired: '物品数量不能为空',
        quantityFormat: '物品数量必须是数字',
        unitPriceRequired: '物品单价不能为空',
        unitPriceFormat: '物品单价格式不正确',
        locationRequired: '领取地点不能为空',
        borrowIdRequired: '借用ID不能为空',
        imageSize: '图片大小不能超过2MB'
      }
    }
  }
}